//This is the default placeholder Markup for the App

const placeholder=`# Hello 👋

markItDown is a markdown editor ✍ designed by [Aromal Anil](https://github.com/aromalanil)

## 🤷‍♂️ What can you write here

1. Code
  * eg: \`<div></div>\` or
  *eg:

  \`\`\`bash
  npm install happiness
  \`\`\`

2. Blockquote
	* eg: 
> Blockquote

3. Different Text Style
  * **Bold**
  * *Italic*
  * ~~Strikethrough~~
  
4. Tables

    | Name          | Age           | Salary|
    | ------------- |:-------------:| -----:|
    | Robert        | 50            | $16000|
    | Clint         | 24            |$120000|
    | Tommy         | 18            | $1000 |

5. Images
  
    ![React](https://d2eip9sf3oo6c2.cloudfront.net/series/square_covers/000/000/412/square_256/AccessibleReact_1000.png)


## 🛸 Technologies Used

*  React.js
*  SCSS
*  Javascript

`;

export default placeholder;